import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.chassis');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';


@Component({
 standalone: false,
 selector: 'wiz-page-kiera-chassis',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.chassis/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.chassis-node-drag-source,
.chassis-slot [draggable=true] {
  user-select: none;
  -webkit-user-drag: element;
}

.chassis-node-drag-source {
  cursor: grab;
}

.chassis-node-drag-source:active,
.chassis-slot [draggable=true]:active {
  cursor: grabbing;
}

.chassis-slot {
  position: relative;
}

.chassis-slot-shadow > td {
  background: rgba(37, 99, 235, 0.12) !important;
  box-shadow: inset 0 2px 0 rgba(37, 99, 235, 0.55), inset 0 -2px 0 rgba(37, 99, 235, 0.55);
}

.chassis-slot-shadow > td:first-child {
  box-shadow: inset 2px 0 0 rgba(37, 99, 235, 0.55), inset 0 2px 0 rgba(37, 99, 235, 0.55), inset 0 -2px 0 rgba(37, 99, 235, 0.55);
}

.chassis-slot-shadow > td:last-of-type {
  box-shadow: inset -2px 0 0 rgba(37, 99, 235, 0.55), inset 0 2px 0 rgba(37, 99, 235, 0.55), inset 0 -2px 0 rgba(37, 99, 235, 0.55);
}

@media (max-width: 1024px) {
  :host {
    height: auto;
    min-height: 100%;
  }
}`],
})
export class PageKieraChassisComponent implements OnInit {
    public loading: boolean = true;
    public editorLoading: boolean = false;
    public saving: boolean = false;
    public savingModel: boolean = false;
    public deletingId: number = 0;
    public deletingModelId: string = '';
    public errorMessage: string = '';
    public noticeMessage: string = '';

    public chassis: any[] = [];
    public models: any[] = [];
    public zones: any[] = [];
    public racks: any[] = [];

    public searchText: string = '';
    public statusFilter: string = 'all';
    public zoneFilter: string = 'all';
    public rackFilter: string = 'all';
    public modelFilter: string = 'all';
    public listPage: number = 1;
    public listPageSize: number = 10;
    public selectedChassisIds: number[] = [];

    public editorOpen: boolean = false;
    public editorStep: number = 1;
    public editingId: number = 0;
    public editorError: string = '';
    public registrationMode: string = 'single';
    public selectedModelId: string = '';
    public form: any = this.emptyForm();
    public bulkForm: any = this.emptyBulkForm();

    public modelManagerOpen: boolean = false;
    public modelManagerError: string = '';
    public modelManagerNotice: string = '';
    public modelSearchText: string = '';
    public modelPage: number = 1;
    public modelPageSize: number = 5;
    public newModelOpen: boolean = false;
    public modelError: string = '';
    public modelForm: any = this.emptyModelForm();

    public nodeCandidates: any[] = [];
    public includedNodeIds: number[] = [];
    public availableSelection: number[] = [];
    public includedSelection: number[] = [];
    public nodeSearchText: string = '';
    public nodeGroupFilter: string = 'all';
    public clusterFilter: string = 'all';
    public nodePage: number = 1;
    public nodePageSize: number = 10;
    public includedNodePage: number = 1;
    public includedNodePageSize: number = 10;
    public mappingDirection: string = 'forward';
    public bulkMappingMode: string = 'auto';
    public bulkSortKey: string = 'name';
    public bulkManualOpen: boolean = false;
    public bulkManualChassisIndex: number = 0;
    public bulkManualPlacements: any[] = [];
    public bulkManualDraftPlacements: any[] = [];
    public bulkManualSearchText: string = '';
    public bulkManualError: string = '';
    public bulkManualDraggedNodeId: number = 0;
    public bulkManualDragShadow: any = null;
    public bulkManualUnassignActive: boolean = false;
    private bulkManualReturnMode: string = 'auto';

    public placements: any[] = [];
    public draggedNodeId: number = 0;
    public dragShadow: any = null;
    public placementRemoveDropActive: boolean = false;
    private draggedFromPreview: boolean = false;
    private dragRenderPending: boolean = false;
    private initialState: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public emptyForm(): any {
        return {
            name: '',
            model: '',
            serial: '',
            description: '',
            slot_rows: 1,
            slot_columns: 4,
            unit_size: 2,
            active: true,
            rack_record_id: 0,
            rack_name: '',
            unit_order: 0,
        };
    }

    public emptyBulkForm(): any {
        return {
            count: 10,
            prefix: 'C6400-',
            start: 1,
            digits: 3,
        };
    }

    public emptyModelForm(): any {
        return {
            name: '',
            manufacturer: '',
            rack_size: 2,
            slot_count: 4,
            description: '',
            product_url: '',
            image: '',
            node_types: ['Compute Node'],
        };
    }

    public get canWrite(): boolean {
        const role = String(this.service.auth.session?.role || '').toLowerCase();
        return role === 'admin' || role === 'superadmin';
    }

    public async load(render: boolean = true) {
        this.loading = true;
        this.errorMessage = '';
        if (render) await this.service.render();
        try {
            const { code, data } = await wiz.call('load');
            if (code !== 200) {
                this.errorMessage = data?.message || 'Chassis 목록을 불러오지 못했습니다.';
                return;
            }
            this.applySnapshot(data);
        } catch (error) {
            this.errorMessage = String(error || 'Chassis 목록을 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            if (render) await this.service.render();
        }
    }

    private applySnapshot(data: any) {
        this.chassis = Array.isArray(data?.chassis) ? data.chassis : [];
        this.models = Array.isArray(data?.models) ? data.models : [];
        this.zones = Array.isArray(data?.zones) ? data.zones : [];
        this.racks = Array.isArray(data?.racks) ? data.racks : [];
        const selectedModelExists = this.models.some(
            (model: any) => String(model?.id || '') === String(this.selectedModelId),
        );
        if ((!this.selectedModelId || !selectedModelExists) && this.models.length > 0) {
            this.selectedModelId = String(this.models[0]?.id || '');
        }
        if (this.models.length === 0) {
            this.selectedModelId = '';
        }
        if (
            this.modelFilter !== 'all'
            && !this.models.some(
                (model: any) => String(model?.name || '') === String(this.modelFilter),
            )
        ) {
            this.modelFilter = 'all';
        }
        this.listPage = Math.min(this.listPage, this.listTotalPages);
        this.modelPage = Math.min(this.modelPage, this.modelTotalPages);
        this.selectedChassisIds = this.selectedChassisIds.filter(
            (id: number) => this.chassis.some(
                (item: any) => Number(item?.id || 0) === Number(id),
            ),
        );
    }

    public get normalizedListPageSize(): number {
        const size = Math.floor(Number(this.listPageSize || 10));
        return Number.isFinite(size) ? Math.max(5, Math.min(100, size)) : 10;
    }

    public rackRecord(item: any): any {
        const rackId = Number(item?.rack_record_id || item?.rack_id || 0);
        return this.racks.find(
            (rack: any) => Number(rack?.rack_record_id || rack?.id || 0) === rackId,
        ) || null;
    }

    public chassisZoneName(item: any): string {
        return String(this.rackRecord(item)?.zone_name || '미할당');
    }

    public chassisStatusKey(item: any): string {
        if (!this.isChassisActive(item)) return 'error';
        if (Number(item?.rack_record_id || 0) <= 0) return 'unassigned';
        if (Number(item?.node_count || 0) < Number(item?.slot_count || 0)) return 'warning';
        return 'normal';
    }

    public get filteredChassis(): any[] {
        const term = this.searchText.trim().toLowerCase();
        return this.chassis.filter((item: any) => {
            const status = this.chassisStatusKey(item);
            const rack = this.rackRecord(item);
            if (this.statusFilter !== 'all' && status !== this.statusFilter) return false;
            if (
                this.zoneFilter !== 'all'
                && String(rack?.zone_id || 0) !== String(this.zoneFilter)
            ) return false;
            if (
                this.rackFilter !== 'all'
                && String(item?.rack_record_id || 0) !== String(this.rackFilter)
            ) return false;
            if (
                this.modelFilter !== 'all'
                && String(item?.model || '') !== String(this.modelFilter)
            ) return false;
            if (!term) return true;
            return [
                item?.name,
                item?.model,
                item?.serial,
                item?.description,
                item?.rack_name,
                ...(item?.nodes || []).map((node: any) => node?.name),
            ].some((value: any) => String(value || '').toLowerCase().includes(term));
        }).sort((left: any, right: any) => String(left?.name || '').localeCompare(
            String(right?.name || ''),
            undefined,
            { numeric: true, sensitivity: 'base' },
        ));
    }

    public get listTotalPages(): number {
        return Math.max(
            1,
            Math.ceil(this.filteredChassis.length / this.normalizedListPageSize),
        );
    }

    public get pagedChassis(): any[] {
        const page = Math.max(1, Math.min(this.listPage, this.listTotalPages));
        const start = (page - 1) * this.normalizedListPageSize;
        return this.filteredChassis.slice(start, start + this.normalizedListPageSize);
    }

    public get listStartIndex(): number {
        if (this.filteredChassis.length === 0) return 0;
        return (this.listPage - 1) * this.normalizedListPageSize + 1;
    }

    public get listEndIndex(): number {
        return Math.min(
            this.filteredChassis.length,
            this.listPage * this.normalizedListPageSize,
        );
    }

    public get allPagedChassisSelected(): boolean {
        return this.pagedChassis.length > 0 && this.pagedChassis.every(
            (item: any) => this.selectedChassisIds.includes(Number(item?.id || 0)),
        );
    }

    public async togglePagedChassis() {
        const ids = this.pagedChassis.map((item: any) => Number(item?.id || 0));
        const idSet = new Set(ids);
        this.selectedChassisIds = this.allPagedChassisSelected
            ? this.selectedChassisIds.filter((id: number) => !idSet.has(id))
            : Array.from(new Set([...this.selectedChassisIds, ...ids]));
        await this.service.render();
    }

    public async toggleChassisSelection(item: any, event?: Event) {
        event?.stopPropagation();
        const id = Number(item?.id || 0);
        if (id <= 0) return;
        this.selectedChassisIds = this.selectedChassisIds.includes(id)
            ? this.selectedChassisIds.filter((value: number) => value !== id)
            : [...this.selectedChassisIds, id];
        await this.service.render();
    }

    public async onListFilterChange() {
        this.listPage = 1;
        await this.service.render();
    }

    public async onListPageSizeChange() {
        this.listPageSize = this.normalizedListPageSize;
        this.listPage = 1;
        await this.service.render();
    }

    public async changeListPage(page: number) {
        this.listPage = Math.max(1, Math.min(Number(page || 1), this.listTotalPages));
        await this.service.render();
    }

    public async resetListFilters() {
        this.searchText = '';
        this.statusFilter = 'all';
        this.zoneFilter = 'all';
        this.rackFilter = 'all';
        this.modelFilter = 'all';
        this.listPage = 1;
        await this.service.render();
    }

    public async showUnassigned() {
        this.statusFilter = 'unassigned';
        this.listPage = 1;
        await this.service.render();
    }

    public async refresh() {
        await this.load();
    }

    public exportCsv() {
        const header = [
            'Chassis 이름',
            'Model',
            'Slot 수',
            'Node 매핑',
            'Rack',
            'U 위치',
            '상태',
            '등록일',
        ];
        const rows = this.filteredChassis.map((item: any) => [
            item?.name,
            item?.model,
            item?.slot_count,
            String(item?.node_count || 0) + ' / ' + String(item?.slot_count || 0),
            item?.rack_name || '미배치',
            this.chassisUnitLabel(item),
            this.chassisStatusLabel(item),
            item?.created || '',
        ]);
        const quote = (value: any) => {
            const text = String(value ?? '');
            return '"' + text.replace(/"/g, '""') + '"';
        };
        const csv = [header, ...rows]
            .map((row: any[]) => row.map(quote).join(','))
            .join('\n');
        const blob = new Blob(['\ufeff' + csv], {
            type: 'text/csv;charset=utf-8',
        });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'chassis-' + new Date().toISOString().slice(0, 10) + '.csv';
        anchor.click();
        URL.revokeObjectURL(url);
    }

    public get assignedCount(): number {
        return this.chassis.filter(
            (item: any) => Number(item?.rack_record_id || 0) > 0,
        ).length;
    }

    public get unassignedCount(): number {
        return this.chassis.length - this.assignedCount;
    }

    public get totalNodeCount(): number {
        return this.chassis.reduce(
            (total: number, item: any) => total + Number(item?.node_count || 0),
            0,
        );
    }

    public get totalSlotCount(): number {
        return this.chassis.reduce(
            (total: number, item: any) => total + Number(item?.slot_count || 0),
            0,
        );
    }

    public get rackPlacementRate(): number {
        if (this.chassis.length === 0) return 0;
        return Math.round((this.assignedCount / this.chassis.length) * 1000) / 10;
    }

    public statusCount(status: string): number {
        return this.chassis.filter(
            (item: any) => this.chassisStatusKey(item) === status,
        ).length;
    }

    public get statusChartBackground(): string {
        const total = Math.max(1, this.chassis.length);
        const normal = (this.statusCount('normal') / total) * 100;
        const warning = normal + (this.statusCount('warning') / total) * 100;
        const error = warning + (this.statusCount('error') / total) * 100;
        return 'conic-gradient(#22c55e 0% ' + normal
            + '%, #f59e0b ' + normal + '% ' + warning
            + '%, #ef4444 ' + warning + '% ' + error
            + '%, #94a3b8 ' + error + '% 100%)';
    }

    public isChassisActive(item: any): boolean {
        return item?.active !== false && item?.active !== 0 && item?.active !== '0';
    }

    public chassisStatusLabel(item: any): string {
        const status = this.chassisStatusKey(item);
        if (status === 'normal') return '정상';
        if (status === 'warning') return '경고';
        if (status === 'error') return '비활성';
        return '미배치';
    }

    public chassisStatusClass(item: any): string {
        const status = this.chassisStatusKey(item);
        if (status === 'normal') return 'bg-emerald-50 text-emerald-700';
        if (status === 'warning') return 'bg-amber-50 text-amber-700';
        if (status === 'error') return 'bg-rose-50 text-rose-700';
        return 'bg-slate-100 text-slate-600';
    }

    public chassisUnitLabel(item: any): string {
        const start = Number(item?.unit_order || item?.unit || 0);
        const size = Math.max(1, Number(item?.unit_size || item?.rack_size || 1));
        if (start <= 0) return '-';
        const end = start + size - 1;
        return start === end ? String(start) + 'U' : String(start) + '~' + String(end) + 'U';
    }

    public mappingRate(item: any): number {
        const slots = Math.max(1, Number(item?.slot_count || 0));
        return Math.min(100, Math.round((Number(item?.node_count || 0) / slots) * 100));
    }

    public formatDate(value: any): string {
        if (!value) return '-';
        const date = new Date(String(value).replace(' ', 'T'));
        if (Number.isNaN(date.getTime())) return String(value);
        return date.toLocaleDateString('ko-KR');
    }

    private editorState(): string {
        const placements = this.placements
            .map((item: any) => ({
                node_id: Number(item?.node_id || 0),
                slot_row: Number(item?.slot_row || 0),
                slot_column: Number(item?.slot_column || 0),
            }))
            .sort((left: any, right: any) => left.node_id - right.node_id);
        const bulkManualPlacements = this.bulkManualPlacements
            .map((item: any) => ({
                chassis_index: Number(item?.chassis_index || 0),
                node_id: Number(item?.node_id || 0),
                slot_row: Number(item?.slot_row || 0),
                slot_column: Number(item?.slot_column || 0),
            }))
            .sort((left: any, right: any) => (
                left.chassis_index - right.chassis_index
                || left.slot_row - right.slot_row
                || left.slot_column - right.slot_column
            ));
        return JSON.stringify({
            registrationMode: this.registrationMode,
            selectedModelId: this.selectedModelId,
            form: {
                name: String(this.form?.name || ''),
                model: String(this.form?.model || ''),
                serial: String(this.form?.serial || ''),
                description: String(this.form?.description || ''),
                slot_rows: Number(this.form?.slot_rows || 0),
                slot_columns: Number(this.form?.slot_columns || 0),
                unit_size: Number(this.form?.unit_size || 0),
                active: Boolean(this.form?.active),
                rack_record_id: Number(this.form?.rack_record_id || 0),
                unit_order: Number(this.form?.unit_order || 0),
            },
            bulk: {
                count: Number(this.bulkForm?.count || 0),
                prefix: String(this.bulkForm?.prefix || ''),
                start: Number(this.bulkForm?.start || 0),
                digits: Number(this.bulkForm?.digits || 0),
                mappingMode: this.bulkMappingMode,
                sortKey: this.bulkSortKey,
                direction: this.mappingDirection,
                manualPlacements: bulkManualPlacements,
            },
            included: this.includedNodeIds.map(Number).sort((a, b) => a - b),
            placements,
        });
    }

    public get hasUnsavedChanges(): boolean {
        return Boolean(this.initialState) && this.editorState() !== this.initialState;
    }

    public async openCreate() {
        await this.openEditor(null);
    }

    public openDetail(item: any) {
        const chassisId = Number(item?.id || 0);
        if (chassisId <= 0) return;
        this.service.href(`/kiera/chassis/${chassisId}/summary`);
    }

    public async openEdit(item: any, event?: Event) {
        event?.stopPropagation();
        await this.openEditor(item);
    }

    private async openEditor(item: any) {
        this.editingId = Number(item?.id || 0);
        this.editorStep = 1;
        this.editorError = '';
        this.editorLoading = true;
        this.registrationMode = 'single';
        this.form = this.emptyForm();
        this.bulkForm = this.emptyBulkForm();
        this.nodeCandidates = [];
        this.includedNodeIds = [];
        this.availableSelection = [];
        this.includedSelection = [];
        this.nodeSearchText = '';
        this.nodeGroupFilter = 'all';
        this.clusterFilter = 'all';
        this.nodePage = 1;
        this.includedNodePage = 1;
        this.mappingDirection = 'forward';
        this.bulkMappingMode = 'auto';
        this.bulkSortKey = 'name';
        this.bulkManualOpen = false;
        this.bulkManualChassisIndex = 0;
        this.bulkManualPlacements = [];
        this.bulkManualDraftPlacements = [];
        this.bulkManualSearchText = '';
        this.bulkManualError = '';
        this.bulkManualReturnMode = 'auto';
        this.clearBulkManualDragState();
        this.placements = [];
        this.clearDragState();
        this.initialState = '';
        if (this.models.length > 0) {
            this.selectedModelId = String(this.models[0]?.id || '');
            this.applySelectedModel(false);
        }
        this.editorOpen = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('editor', { id: this.editingId });
            if (code !== 200) {
                this.editorError = data?.message || 'Chassis 편집 정보를 불러오지 못했습니다.';
                return;
            }
            const record = data?.chassis || {};
            if (this.editingId > 0) {
                const model = this.models.find(
                    (candidate: any) => String(candidate?.name || '') === String(record?.model || ''),
                );
                this.selectedModelId = String(model?.id || '');
                this.form = {
                    name: String(record?.name || ''),
                    model: String(record?.model || ''),
                    serial: String(record?.serial || ''),
                    description: String(record?.description || ''),
                    slot_rows: Number(record?.slot_rows || 1),
                    slot_columns: Number(record?.slot_columns || 4),
                    unit_size: Number(record?.rack_size || record?.unit_size || 2),
                    active: record?.active !== false && record?.active !== 0,
                    rack_record_id: Number(record?.rack_id || 0),
                    rack_name: String(item?.rack_name || record?.rack_name || ''),
                    unit_order: Number(record?.unit || item?.unit_order || 0),
                };
            }
            this.nodeCandidates = Array.isArray(data?.nodes) ? data.nodes : [];
            this.placements = Array.isArray(data?.placements)
                ? data.placements.map((placement: any) => ({ ...placement }))
                : [];
            this.includedNodeIds = this.placements
                .map((placement: any) => Number(placement?.node_id || 0))
                .filter((nodeId: number) => nodeId > 0);
            this.initialState = this.editorState();
        } catch (error) {
            this.editorError = String(error || 'Chassis 편집 정보를 불러오지 못했습니다.');
        } finally {
            this.editorLoading = false;
            await this.service.render();
        }
    }

    public async closeEditor(force: boolean = false) {
        if (this.saving && !force) return;
        if (!force && this.hasUnsavedChanges) {
            const confirmed = await this.service.modal.show({
                title: '저장하지 않은 수정사항',
                message: 'Chassis 등록 내용을 저장하지 않고 닫으시겠습니까?',
                action: '변경사항 버리기',
                cancel: '계속 편집',
                status: 'warning',
                actionBtn: 'warning',
            });
            if (!confirmed) return;
        }
        this.editorOpen = false;
        this.editorStep = 1;
        this.editorError = '';
        this.initialState = '';
        this.newModelOpen = false;
        this.bulkManualOpen = false;
        this.bulkManualDraftPlacements = [];
        this.clearBulkManualDragState();
        this.clearDragState();
        await this.service.render();
    }

    public async selectRegistrationMode(mode: string) {
        if (this.editingId > 0) return;
        this.registrationMode = mode === 'bulk' ? 'bulk' : 'single';
        this.editorError = '';
        this.includedNodeIds = [];
        this.availableSelection = [];
        this.includedSelection = [];
        this.placements = [];
        this.bulkManualOpen = false;
        this.bulkManualPlacements = [];
        this.bulkManualDraftPlacements = [];
        this.bulkManualError = '';
        this.clearBulkManualDragState();
        await this.service.render();
    }

    public get selectedModel(): any {
        return this.models.find(
            (model: any) => String(model?.id || '') === String(this.selectedModelId),
        ) || null;
    }

    public get selectedModelPrimaryNodeType(): string {
        return String((this.selectedModel?.node_types || [])[0] || '-');
    }

    private defaultPrefixForModel(model: any): string {
        const name = String(model?.name || 'Chassis');
        const match = name.match(/[A-Za-z]+\d+/g);
        if (match && match.length > 0) return match[match.length - 1].toUpperCase() + '-';
        const compact = name.replace(/[^A-Za-z0-9]/g, '').slice(-8).toUpperCase();
        return (compact || 'CHASSIS') + '-';
    }

    private applySelectedModel(preserveName: boolean = true) {
        const model = this.selectedModel;
        if (!model) return;
        this.form.model = String(model?.name || '');
        this.form.slot_rows = Math.max(1, Number(model?.slot_rows || 1));
        this.form.slot_columns = Math.max(
            1,
            Number(model?.slot_columns || model?.slot_count || 1),
        );
        this.form.unit_size = Math.max(1, Number(model?.rack_size || 1));
        if (!preserveName || !String(this.form?.description || '').trim()) {
            this.form.description = String(model?.description || '');
        }
        if (!String(this.bulkForm?.prefix || '').trim() || !preserveName) {
            this.bulkForm.prefix = this.defaultPrefixForModel(model);
        }
    }

    public async onSelectedModelChange() {
        this.applySelectedModel(true);
        this.placements = this.placements.filter((placement: any) => (
            Number(placement?.slot_row || 0) <= Number(this.form?.slot_rows || 1)
            && Number(placement?.slot_column || 0) <= Number(this.form?.slot_columns || 1)
        ));
        this.reconcileBulkManualPlacements();
        this.editorError = this.nodeSelectionCapacityError
            || this.bulkManualPlacementError;
        await this.service.render();
    }

    public async openModelManager() {
        if (!this.canWrite) return;
        this.modelManagerError = '';
        this.modelManagerNotice = '';
        this.modelSearchText = '';
        this.modelPage = 1;
        this.modelManagerOpen = true;
        await this.service.render();
    }

    public async closeModelManager() {
        if (this.deletingModelId) return;
        this.modelManagerOpen = false;
        this.modelManagerError = '';
        this.modelManagerNotice = '';
        await this.service.render();
    }

    public get normalizedModelPageSize(): number {
        const size = Math.floor(Number(this.modelPageSize || 5));
        return Number.isFinite(size) ? Math.max(5, Math.min(50, size)) : 5;
    }

    public get filteredModels(): any[] {
        const term = String(this.modelSearchText || '').trim().toLowerCase();
        if (!term) return this.models;
        return this.models.filter((model: any) => [
            model?.name,
            model?.manufacturer,
            model?.description,
            model?.product_url,
            this.modelCatalogLabel(model),
            ...(Array.isArray(model?.node_types) ? model.node_types : []),
        ].some(
            (value: any) => String(value || '').toLowerCase().includes(term),
        ));
    }

    public get modelTotalPages(): number {
        return Math.max(
            1,
            Math.ceil(this.filteredModels.length / this.normalizedModelPageSize),
        );
    }

    public get pagedModels(): any[] {
        const page = Math.max(1, Math.min(this.modelPage, this.modelTotalPages));
        const start = (page - 1) * this.normalizedModelPageSize;
        return this.filteredModels.slice(start, start + this.normalizedModelPageSize);
    }

    public get modelStartIndex(): number {
        if (this.filteredModels.length === 0) return 0;
        const page = Math.max(1, Math.min(this.modelPage, this.modelTotalPages));
        return (page - 1) * this.normalizedModelPageSize + 1;
    }

    public get modelEndIndex(): number {
        const page = Math.max(1, Math.min(this.modelPage, this.modelTotalPages));
        return Math.min(
            this.filteredModels.length,
            page * this.normalizedModelPageSize,
        );
    }

    public async onModelSearchChange() {
        this.modelPage = 1;
        await this.service.render();
    }

    public async clearModelSearch() {
        this.modelSearchText = '';
        this.modelPage = 1;
        await this.service.render();
    }

    public async onModelPageSizeChange() {
        this.modelPageSize = this.normalizedModelPageSize;
        this.modelPage = 1;
        await this.service.render();
    }

    public async changeModelPage(page: number) {
        this.modelPage = Math.max(
            1,
            Math.min(Number(page || 1), this.modelTotalPages),
        );
        await this.service.render();
    }

    public get customModelCount(): number {
        return this.models.filter(
            (model: any) => String(model?.catalog_source || '') === 'custom',
        ).length;
    }

    public modelUsageCount(model: any): number {
        const usage = Number(model?.usage_count);
        if (Number.isFinite(usage) && usage >= 0) return usage;
        const name = String(model?.name || '').trim().toLowerCase();
        return this.chassis.filter(
            (item: any) => String(item?.model || '').trim().toLowerCase() === name,
        ).length;
    }

    public modelCatalogLabel(model: any): string {
        const source = String(model?.catalog_source || '');
        if (source === 'builtin') return '기본 Model';
        if (source === 'custom') return '사용자 등록';
        return '기존 Chassis 참조';
    }

    public modelCatalogClass(model: any): string {
        const source = String(model?.catalog_source || '');
        if (source === 'builtin') return 'bg-blue-50 text-blue-700';
        if (source === 'custom') return 'bg-emerald-50 text-emerald-700';
        return 'bg-slate-100 text-slate-600';
    }

    public modelDeleteHint(model: any): string {
        const usage = this.modelUsageCount(model);
        if (usage > 0) return '사용 중인 Chassis가 있어 삭제할 수 없습니다.';
        if (model?.deletable !== true) return '사용자 등록 Model만 삭제할 수 있습니다.';
        return 'Model 삭제';
    }

    public async deleteModel(model: any) {
        if (!this.canWrite || this.deletingModelId) return;
        this.modelManagerError = '';
        this.modelManagerNotice = '';
        if (model?.deletable !== true) {
            this.modelManagerError = '사용자 등록 Model만 삭제할 수 있습니다.';
            await this.service.render();
            return;
        }
        const usage = this.modelUsageCount(model);
        if (usage > 0) {
            this.modelManagerError = '이 Model을 사용하는 Chassis '
                + usage + '대가 있어 삭제할 수 없습니다.';
            await this.service.render();
            return;
        }
        const modelId = String(model?.id || '');
        if (!modelId) return;
        const confirmed = await this.service.modal.show({
            title: 'Chassis Model 삭제',
            message: '\'' + String(model?.name || 'Model')
                + '\'을(를) 삭제하시겠습니까? 삭제한 Model은 복구할 수 없습니다.',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error',
        });
        if (!confirmed) return;

        this.deletingModelId = modelId;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete_model', { id: modelId });
            if (code !== 200) {
                this.modelManagerError = data?.message || 'Model을 삭제하지 못했습니다.';
                return;
            }
            this.applySnapshot(data?.snapshot);
            this.modelManagerNotice = String(model?.name || 'Model')
                + '을(를) 삭제했습니다.';
        } catch (error) {
            this.modelManagerError = String(error || 'Model을 삭제하지 못했습니다.');
        } finally {
            this.deletingModelId = '';
            await this.service.render();
        }
    }

    public async openNewModel() {
        this.modelForm = this.emptyModelForm();
        this.modelError = '';
        this.newModelOpen = true;
        await this.service.render();
    }

    public async closeNewModel() {
        if (this.savingModel) return;
        this.newModelOpen = false;
        this.modelError = '';
        await this.service.render();
    }

    public get modelFormError(): string {
        if (!String(this.modelForm?.name || '').trim()) return 'Model 이름을 입력하세요.';
        if (!String(this.modelForm?.manufacturer || '').trim()) return '제조사를 입력하세요.';
        const rackSize = Number(this.modelForm?.rack_size || 0);
        const slotCount = Number(this.modelForm?.slot_count || 0);
        if (!Number.isInteger(rackSize) || rackSize < 1 || rackSize > 100) {
            return 'U 크기는 1~100 사이의 정수여야 합니다.';
        }
        if (!Number.isInteger(slotCount) || slotCount < 1 || slotCount > 64) {
            return 'Slot 수는 1~64 사이의 정수여야 합니다.';
        }
        return '';
    }

    public async toggleModelNodeType(type: string) {
        const values = Array.isArray(this.modelForm?.node_types)
            ? [...this.modelForm.node_types]
            : [];
        this.modelForm.node_types = values.includes(type)
            ? values.filter((value: string) => value !== type)
            : [...values, type];
        await this.service.render();
    }

    public modelNodeTypeSelected(type: string): boolean {
        return (this.modelForm?.node_types || []).includes(type);
    }

    public async onModelImageChange(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            this.modelError = '이미지 파일만 업로드할 수 있습니다.';
            await this.service.render();
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            this.modelError = 'Model 이미지는 5MB 이하만 업로드할 수 있습니다.';
            await this.service.render();
            return;
        }
        const reader = new FileReader();
        reader.onload = async () => {
            this.modelForm.image = String(reader.result || '');
            this.modelError = '';
            await this.service.render();
        };
        reader.readAsDataURL(file);
    }

    public async saveModel() {
        this.modelError = this.modelFormError;
        if (this.modelError) {
            await this.service.render();
            return;
        }
        this.savingModel = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save_model', {
                data: JSON.stringify(this.modelForm),
            });
            if (code !== 200) {
                this.modelError = data?.message || 'Model을 등록하지 못했습니다.';
                return;
            }
            this.applySnapshot(data?.snapshot);
            this.selectedModelId = String(data?.model?.id || '');
            this.applySelectedModel(false);
            if (this.modelManagerOpen) {
                this.modelManagerError = '';
                this.modelManagerNotice = String(data?.model?.name || 'Model')
                    + '을(를) 등록했습니다.';
                this.modelSearchText = '';
                this.modelPage = this.modelTotalPages;
            }
            this.newModelOpen = false;
            this.modelError = '';
        } catch (error) {
            this.modelError = String(error || 'Model을 등록하지 못했습니다.');
        } finally {
            this.savingModel = false;
            await this.service.render();
        }
    }

    public get selectedRack(): any {
        const rackId = Number(this.form?.rack_record_id || 0);
        return this.racks.find(
            (rack: any) => Number(rack?.rack_record_id || rack?.id || 0) === rackId,
        ) || null;
    }

    public get activeRacks(): any[] {
        return this.racks.filter(
            (rack: any) => rack?.active !== false && rack?.active !== 0,
        );
    }

    public get rackUnitOptions(): number[] {
        const capacity = Math.max(
            0,
            Number(this.selectedRack?.rack_size_u || this.selectedRack?.capacity_u || 0),
        );
        return Array.from({ length: capacity }, (_value, index) => index + 1);
    }

    public get selectedRackEndUnit(): number {
        const start = Number(this.form?.unit_order || 0);
        if (start <= 0) return 0;
        return start + Math.max(1, Number(this.form?.unit_size || 1)) - 1;
    }

    public async onRackChange() {
        const rack = this.selectedRack;
        this.form.rack_name = String(rack?.rack_name || rack?.name || '');
        this.form.unit_order = 0;
        this.editorError = '';
        await this.service.render();
    }

    public get rackPlacementError(): string {
        const rackId = Number(this.form?.rack_record_id || 0);
        if (rackId <= 0) return '';
        const start = Number(this.form?.unit_order || 0);
        const capacity = Number(
            this.selectedRack?.rack_size_u || this.selectedRack?.capacity_u || 0,
        );
        if (start <= 0) return 'Rack 배치 시작 U를 선택하세요.';
        if (this.selectedRackEndUnit > capacity) {
            return '선택한 Chassis가 Rack 용량 범위를 벗어납니다.';
        }
        return '';
    }

    public get generatedChassisNames(): string[] {
        const count = Math.max(0, Math.min(500, Math.floor(Number(this.bulkForm?.count || 0))));
        const start = Math.max(0, Math.floor(Number(this.bulkForm?.start || 0)));
        const digits = Math.max(1, Math.min(8, Math.floor(Number(this.bulkForm?.digits || 1))));
        const prefix = String(this.bulkForm?.prefix || '');
        return Array.from({ length: count }, (_value, index) => (
            prefix + String(start + index).padStart(digits, '0')
        ));
    }

    public get bulkNamePreview(): string {
        const names = this.generatedChassisNames;
        if (names.length === 0) return '-';
        if (names.length === 1) return names[0];
        return names[0] + ' ~ ' + names[names.length - 1]
            + ' (총 ' + names.length + '대)';
    }

    public get bulkTotalSlots(): number {
        return this.generatedChassisNames.length * this.slotCount;
    }

    public get stepOneError(): string {
        if (!this.selectedModel) return 'Chassis Model을 선택하세요.';
        const rows = Number(this.form?.slot_rows || 0);
        const columns = Number(this.form?.slot_columns || 0);
        if (!Number.isInteger(rows) || rows < 1 || rows > 16) {
            return 'Chassis 행은 1~16 사이의 정수여야 합니다.';
        }
        if (!Number.isInteger(columns) || columns < 1 || columns > 64) {
            return 'Chassis 열은 1~64 사이의 정수여야 합니다.';
        }
        if (rows * columns > 64) return 'Chassis 슬롯은 최대 64개까지 구성할 수 있습니다.';
        if (this.registrationMode === 'bulk' && this.editingId <= 0) {
            const count = Number(this.bulkForm?.count || 0);
            const start = Number(this.bulkForm?.start || 0);
            const digits = Number(this.bulkForm?.digits || 0);
            if (!Number.isInteger(count) || count < 1 || count > 500) {
                return '생성 수는 1~500 사이의 정수여야 합니다.';
            }
            if (!String(this.bulkForm?.prefix || '').trim()) return '이름 Prefix를 입력하세요.';
            if (!Number.isInteger(start) || start < 0) return '시작 번호를 확인하세요.';
            if (!Number.isInteger(digits) || digits < 1 || digits > 8) {
                return '자리 수는 1~8 사이의 정수여야 합니다.';
            }
            const existingNames = new Set(
                this.chassis.map((item: any) => String(item?.name || '').toLowerCase()),
            );
            const conflict = this.generatedChassisNames.find(
                (name: string) => existingNames.has(name.toLowerCase()),
            );
            if (conflict) return conflict + ' 이름은 이미 사용 중입니다.';
            return '';
        }
        if (!String(this.form?.name || '').trim()) return 'Chassis 이름을 입력하세요.';
        const duplicate = this.chassis.some((item: any) => (
            Number(item?.id || 0) !== this.editingId
            && String(item?.name || '').toLowerCase()
                === String(this.form?.name || '').trim().toLowerCase()
        ));
        if (duplicate) return '이미 사용 중인 Chassis 이름입니다.';
        const unitSize = Number(this.form?.unit_size || 0);
        if (!Number.isInteger(unitSize) || unitSize < 1 || unitSize > 100) {
            return 'Chassis 점유 U는 1~100 사이의 정수여야 합니다.';
        }
        return this.rackPlacementError;
    }

    public async onFormChange() {
        this.editorError = '';
        const rows = Number(this.form?.slot_rows || 0);
        const columns = Number(this.form?.slot_columns || 0);
        this.placements = this.placements.filter((placement: any) => (
            Number(placement?.slot_row || 0) <= rows
            && Number(placement?.slot_column || 0) <= columns
        ));
        await this.service.render();
    }

    public async onBulkFormChange() {
        this.reconcileBulkManualPlacements();
        this.editorError = this.nodeSelectionCapacityError
            || this.bulkManualPlacementError;
        await this.service.render();
    }

    private compareNodeNames(left: any, right: any): number {
        return String(left?.name || '').localeCompare(
            String(right?.name || ''),
            undefined,
            { numeric: true, sensitivity: 'base' },
        );
    }

    private nodeById(nodeId: number): any {
        return this.nodeCandidates.find(
            (node: any) => Number(node?.id || 0) === Number(nodeId),
        ) || null;
    }

    public get nodeGroupOptions(): any[] {
        const map = new Map<number, string>();
        for (const node of this.nodeCandidates) {
            const id = Number(node?.group_id || 0);
            map.set(id, String(node?.group_name || '미할당 Group'));
        }
        return Array.from(map.entries())
            .map(([id, name]) => ({ id, name }))
            .sort((left: any, right: any) => left.name.localeCompare(right.name));
    }

    public get clusterOptions(): any[] {
        const map = new Map<number, string>();
        for (const node of this.nodeCandidates) {
            const id = Number(node?.cluster_id || 0);
            if (id <= 0) continue;
            map.set(id, String(node?.cluster_name || ''));
        }
        return Array.from(map.entries())
            .map(([id, name]) => ({ id, name }))
            .sort((left: any, right: any) => left.name.localeCompare(right.name));
    }

    private matchesNodeFilters(node: any): boolean {
        const term = this.nodeSearchText.trim().toLowerCase();
        if (
            this.nodeGroupFilter !== 'all'
            && String(node?.group_id || 0) !== String(this.nodeGroupFilter)
        ) return false;
        if (
            this.clusterFilter !== 'all'
            && String(node?.cluster_id || 0) !== String(this.clusterFilter)
        ) return false;
        if (!term) return true;
        return [
            node?.name,
            node?.ip_address,
            node?.bmc_ip,
            node?.group_name,
            node?.cluster_name,
        ].some((value: any) => String(value || '').toLowerCase().includes(term));
    }

    public get includedNodes(): any[] {
        return this.includedNodeIds
            .map((nodeId: number) => this.nodeById(nodeId))
            .filter((node: any) => Boolean(node))
            .sort((left: any, right: any) => this.compareNodeNames(left, right));
    }

    public get availableNodes(): any[] {
        const includedIds = new Set(this.includedNodeIds.map(Number));
        return this.nodeCandidates
            .filter((node: any) => (
                Boolean(node?.available)
                && !includedIds.has(Number(node?.id || 0))
                && this.matchesNodeFilters(node)
            ))
            .sort((left: any, right: any) => this.compareNodeNames(left, right));
    }

    public get bulkCandidateNodes(): any[] {
        return this.nodeCandidates
            .filter((node: any) => Boolean(node?.available) && this.matchesNodeFilters(node))
            .sort((left: any, right: any) => this.compareNodeNames(left, right));
    }

    public get normalizedPageSize(): number {
        const size = Math.floor(Number(this.nodePageSize || 10));
        return Number.isFinite(size) ? Math.max(5, Math.min(100, size)) : 10;
    }

    public get nodeTotalPages(): number {
        const total = this.registrationMode === 'bulk'
            ? this.bulkCandidateNodes.length
            : this.availableNodes.length;
        return Math.max(1, Math.ceil(total / this.normalizedPageSize));
    }

    public get pagedAvailableNodes(): any[] {
        const rows = this.registrationMode === 'bulk'
            ? this.bulkCandidateNodes
            : this.availableNodes;
        const start = (this.nodePage - 1) * this.normalizedPageSize;
        return rows.slice(start, start + this.normalizedPageSize);
    }

    public get normalizedIncludedPageSize(): number {
        const size = Math.floor(Number(this.includedNodePageSize || 10));
        return Number.isFinite(size) ? Math.max(5, Math.min(100, size)) : 10;
    }

    public get includedNodeTotalPages(): number {
        return Math.max(
            1,
            Math.ceil(this.includedNodes.length / this.normalizedIncludedPageSize),
        );
    }

    public get pagedIncludedNodes(): any[] {
        const start = (this.includedNodePage - 1) * this.normalizedIncludedPageSize;
        return this.includedNodes.slice(
            start,
            start + this.normalizedIncludedPageSize,
        );
    }

    public get allAvailableSelected(): boolean {
        const ids = this.pagedAvailableNodes.map((node: any) => Number(node?.id || 0));
        if (this.registrationMode === 'bulk') {
            return ids.length > 0 && ids.every(
                (nodeId: number) => this.includedNodeIds.includes(nodeId),
            );
        }
        return ids.length > 0 && ids.every(
            (nodeId: number) => this.availableSelection.includes(nodeId),
        );
    }

    public get allIncludedSelected(): boolean {
        return this.pagedIncludedNodes.length > 0 && this.pagedIncludedNodes.every(
            (node: any) => this.includedSelection.includes(Number(node?.id || 0)),
        );
    }

    public async toggleAvailable(node: any) {
        const nodeId = Number(node?.id || 0);
        if (nodeId <= 0) return;
        if (this.registrationMode === 'bulk') {
            this.includedNodeIds = this.includedNodeIds.includes(nodeId)
                ? this.includedNodeIds.filter((id: number) => id !== nodeId)
                : [...this.includedNodeIds, nodeId];
            this.reconcileBulkManualPlacements();
        } else {
            this.availableSelection = this.availableSelection.includes(nodeId)
                ? this.availableSelection.filter((id: number) => id !== nodeId)
                : [...this.availableSelection, nodeId];
        }
        this.editorError = this.nodeSelectionCapacityError
            || this.bulkManualPlacementError;
        await this.service.render();
    }

    public async toggleIncluded(node: any) {
        const nodeId = Number(node?.id || 0);
        if (nodeId <= 0) return;
        this.includedSelection = this.includedSelection.includes(nodeId)
            ? this.includedSelection.filter((id: number) => id !== nodeId)
            : [...this.includedSelection, nodeId];
        await this.service.render();
    }

    public async toggleAllAvailable() {
        const ids = this.pagedAvailableNodes.map((node: any) => Number(node?.id || 0));
        const idSet = new Set(ids);
        if (this.registrationMode === 'bulk') {
            const allSelected = ids.length > 0 && ids.every(
                (id: number) => this.includedNodeIds.includes(id),
            );
            this.includedNodeIds = allSelected
                ? this.includedNodeIds.filter((id: number) => !idSet.has(id))
                : Array.from(new Set([...this.includedNodeIds, ...ids]));
            this.reconcileBulkManualPlacements();
        } else {
            this.availableSelection = this.allAvailableSelected
                ? this.availableSelection.filter((id: number) => !idSet.has(id))
                : Array.from(new Set([...this.availableSelection, ...ids]));
        }
        this.editorError = this.nodeSelectionCapacityError
            || this.bulkManualPlacementError;
        await this.service.render();
    }

    public async toggleAllIncluded() {
        const ids = this.pagedIncludedNodes.map(
            (node: any) => Number(node?.id || 0),
        );
        const idSet = new Set(ids);
        this.includedSelection = this.allIncludedSelected
            ? this.includedSelection.filter((id: number) => !idSet.has(id))
            : Array.from(new Set([...this.includedSelection, ...ids]));
        await this.service.render();
    }

    public async includeSelected() {
        if (this.availableSelection.length === 0) return;
        this.includedNodeIds = Array.from(new Set([
            ...this.includedNodeIds,
            ...this.availableSelection,
        ]));
        this.availableSelection = [];
        this.includedSelection = [];
        this.editorError = this.nodeSelectionCapacityError
            || this.bulkManualPlacementError;
        this.nodePage = Math.min(this.nodePage, this.nodeTotalPages);
        await this.service.render();
    }

    public async excludeSelected() {
        const removedIds = new Set(this.includedSelection.map(Number));
        if (removedIds.size === 0) return;
        this.includedNodeIds = this.includedNodeIds.filter(
            (nodeId: number) => !removedIds.has(Number(nodeId)),
        );
        this.placements = this.placements.filter(
            (placement: any) => !removedIds.has(Number(placement?.node_id || 0)),
        );
        this.availableSelection = [];
        this.includedSelection = [];
        this.editorError = this.nodeSelectionCapacityError
            || this.bulkManualPlacementError;
        this.includedNodePage = Math.min(
            this.includedNodePage,
            this.includedNodeTotalPages,
        );
        await this.service.render();
    }

    public async mapSelectedNodes() {
        if (this.availableSelection.length === 0) return;
        const nextIds = Array.from(new Set([
            ...this.includedNodeIds,
            ...this.availableSelection,
        ]));
        if (nextIds.length > this.slotCount) {
            this.editorError = '선택한 Node가 Slot 수를 초과합니다.';
            await this.service.render();
            return;
        }
        this.includedNodeIds = nextIds;
        this.availableSelection = [];
        await this.autoArrange();
    }

    public async autoMapSingle() {
        if (this.registrationMode !== 'single') return;
        if (this.availableSelection.length > 0) {
            await this.mapSelectedNodes();
            return;
        }
        if (this.includedNodeIds.length === 0) {
            this.includedNodeIds = this.availableNodes
                .slice(0, this.slotCount)
                .map((node: any) => Number(node?.id || 0));
        }
        await this.autoArrange();
    }

    public async clearNodeMapping() {
        if (this.includedNodeIds.length === 0 && this.placements.length === 0) return;
        this.includedNodeIds = [];
        this.availableSelection = [];
        this.includedSelection = [];
        this.placements = [];
        this.bulkManualPlacements = [];
        this.bulkManualDraftPlacements = [];
        this.bulkManualError = '';
        this.clearBulkManualDragState();
        this.editorError = '';
        await this.service.render();
    }

    public async resetNodeFilters() {
        this.nodeSearchText = '';
        this.nodeGroupFilter = 'all';
        this.clusterFilter = 'all';
        this.nodePage = 1;
        await this.service.render();
    }

    public async onNodeSearchChange() {
        this.nodePage = 1;
        await this.service.render();
    }

    public async onNodePageSizeChange() {
        this.nodePageSize = this.normalizedPageSize;
        this.nodePage = 1;
        await this.service.render();
    }

    public async onIncludedNodePageSizeChange() {
        this.includedNodePageSize = this.normalizedIncludedPageSize;
        this.includedNodePage = 1;
        await this.service.render();
    }

    public async changeNodePage(page: number) {
        this.nodePage = Math.max(1, Math.min(Number(page || 1), this.nodeTotalPages));
        await this.service.render();
    }

    public async changeIncludedNodePage(page: number) {
        this.includedNodePage = Math.max(
            1,
            Math.min(Number(page || 1), this.includedNodeTotalPages),
        );
        await this.service.render();
    }

    public get nodeCapacity(): number {
        return this.registrationMode === 'bulk' ? this.bulkTotalSlots : this.slotCount;
    }

    public get nodeSelectionExcessCount(): number {
        if (this.registrationMode === 'bulk' && this.bulkMappingMode === 'none') {
            return 0;
        }
        return Math.max(0, this.includedNodeIds.length - this.nodeCapacity);
    }

    public get nodeSelectionExceedsSlots(): boolean {
        return this.nodeSelectionExcessCount > 0;
    }

    public get nodeSelectionCapacityError(): string {
        if (!this.nodeSelectionExceedsSlots) return '';
        return 'Slot 개수를 ' + this.nodeSelectionExcessCount
            + '개 초과했습니다. 선택한 Node를 해제하세요.';
    }

    public async nextStep() {
        this.editorError = '';
        if (this.editorStep === 1) {
            this.editorError = this.stepOneError;
            if (!this.editorError) this.editorStep = 2;
        } else if (this.editorStep === 2) {
            this.editorError = this.nodeSelectionCapacityError
                || this.bulkManualPlacementError;
            if (
                !this.editorError
                && this.registrationMode === 'single'
                && this.editingId >= 0
            ) {
                this.editorError = this.placementError;
            }
            if (!this.editorError) this.editorStep = 3;
        }
        await this.service.render();
    }

    public async previousStep() {
        this.editorStep = Math.max(1, this.editorStep - 1);
        this.editorError = '';
        this.clearDragState();
        await this.service.render();
    }

    public get slotCount(): number {
        return Math.max(1, Number(this.form?.slot_rows || 1))
            * Math.max(1, Number(this.form?.slot_columns || 1));
    }

    public get slots(): any[] {
        const slots: any[] = [];
        const rows = Math.max(1, Number(this.form?.slot_rows || 1));
        const columns = Math.max(1, Number(this.form?.slot_columns || 1));
        let number = 1;
        for (let row = 1; row <= rows; row++) {
            for (let column = 1; column <= columns; column++) {
                slots.push({ row, column, number, key: String(row) + ':' + String(column) });
                number += 1;
            }
        }
        return slots;
    }

    public get mappingSlots(): any[] {
        return this.mappingDirection === 'reverse'
            ? [...this.slots].reverse()
            : this.slots;
    }

    public trackSlot(_index: number, slot: any): string {
        return String(slot?.key || String(slot?.row || 0) + ':' + String(slot?.column || 0));
    }

    public get slotGridTemplate(): string {
        return 'repeat(' + Math.max(1, Number(this.form?.slot_columns || 1))
            + ', minmax(0, 1fr))';
    }

    public get slotGridGap(): number {
        const columns = Math.max(
            1,
            Math.min(16, Math.floor(Number(this.form?.slot_columns || 1))),
        );
        if (columns <= 2) return 10;
        if (columns <= 4) return 8;
        if (columns <= 8) return 6;
        return 4;
    }

    public get slotRowHeight(): number {
        const columns = Math.max(
            1,
            Math.min(16, Math.floor(Number(this.form?.slot_columns || 1))),
        );
        if (columns <= 2) return 112;
        if (columns <= 4) return 84;
        if (columns <= 8) return 64;
        return 48;
    }

    public placementAt(slot: any): any {
        return this.placements.find((placement: any) => (
            Number(placement?.slot_row || 0) === Number(slot?.row || 0)
            && Number(placement?.slot_column || 0) === Number(slot?.column || 0)
        )) || null;
    }

    public placementForNode(nodeId: number): any {
        return this.placements.find(
            (placement: any) => Number(placement?.node_id || 0) === Number(nodeId),
        ) || null;
    }

    public get mappedPlacements(): any[] {
        return this.slots
            .map((slot: any) => ({ slot, placement: this.placementAt(slot) }))
            .filter((item: any) => Boolean(item.placement));
    }

    public get placementError(): string {
        const includedIds = new Set(this.includedNodeIds.map(Number));
        const placedIds = new Set<number>();
        const slots = new Set<string>();
        for (const placement of this.placements) {
            const nodeId = Number(placement?.node_id || 0);
            const row = Number(placement?.slot_row || 0);
            const column = Number(placement?.slot_column || 0);
            if (!includedIds.has(nodeId)) return '선택 목록에 없는 Node가 배치되어 있습니다.';
            if (placedIds.has(nodeId)) return '같은 Node를 두 번 배치할 수 없습니다.';
            if (row < 1 || row > Number(this.form?.slot_rows || 1)) return 'Node Slot 행을 확인하세요.';
            if (column < 1 || column > Number(this.form?.slot_columns || 1)) return 'Node Slot 열을 확인하세요.';
            const slotKey = String(row) + ':' + String(column);
            if (slots.has(slotKey)) return '같은 Slot에 두 Node를 배치할 수 없습니다.';
            placedIds.add(nodeId);
            slots.add(slotKey);
        }
        if (placedIds.size !== includedIds.size) {
            return '선택한 Node ' + includedIds.size
                + '개를 모두 Chassis Slot에 배치하세요.';
        }
        return '';
    }

    public get unplacedNodeCount(): number {
        return this.includedNodeIds.filter(
            (nodeId: number) => !this.placementForNode(nodeId),
        ).length;
    }

    public async autoArrange() {
        if (this.includedNodeIds.length > this.slotCount) {
            this.editorError = '선택한 Node가 Chassis Slot '
                + this.slotCount + '개를 초과합니다.';
            await this.service.render();
            return;
        }
        const slots = this.mappingSlots;
        this.placements = this.includedNodes.map((node: any, index: number) => ({
            node_id: Number(node?.id || 0),
            name: String(node?.name || ''),
            group_name: String(node?.group_name || ''),
            cluster_name: String(node?.cluster_name || ''),
            ip_address: String(node?.ip_address || ''),
            bmc_ip: String(node?.bmc_ip || ''),
            slot_row: slots[index].row,
            slot_column: slots[index].column,
        }));
        this.editorError = '';
        this.clearDragState();
        await this.service.render();
    }

    private normalizeBulkManualPlacements(rows: any[]): any[] {
        const includedIds = new Set(this.includedNodeIds.map(Number));
        const maxChassis = this.generatedChassisNames.length;
        const maxRow = Math.max(1, Number(this.form?.slot_rows || 1));
        const maxColumn = Math.max(1, Number(this.form?.slot_columns || 1));
        const seenNodes = new Set<number>();
        const seenSlots = new Set<string>();
        const normalized: any[] = [];
        for (const item of Array.isArray(rows) ? rows : []) {
            const chassisIndex = Math.floor(Number(item?.chassis_index));
            const nodeId = Number(item?.node_id || 0);
            const slotRow = Math.floor(Number(item?.slot_row || 0));
            const slotColumn = Math.floor(Number(item?.slot_column || 0));
            const slotKey = chassisIndex + ':' + slotRow + ':' + slotColumn;
            if (
                chassisIndex < 0
                || chassisIndex >= maxChassis
                || nodeId <= 0
                || !includedIds.has(nodeId)
                || slotRow < 1
                || slotRow > maxRow
                || slotColumn < 1
                || slotColumn > maxColumn
                || seenNodes.has(nodeId)
                || seenSlots.has(slotKey)
            ) continue;
            const node = this.nodeById(nodeId);
            if (!node) continue;
            seenNodes.add(nodeId);
            seenSlots.add(slotKey);
            normalized.push({
                chassis_index: chassisIndex,
                node_id: nodeId,
                name: String(node?.name || 'Node-' + nodeId),
                group_name: String(node?.group_name || ''),
                cluster_name: String(node?.cluster_name || ''),
                ip_address: String(node?.ip_address || ''),
                bmc_ip: String(node?.bmc_ip || ''),
                slot_row: slotRow,
                slot_column: slotColumn,
            });
        }
        return normalized.sort((left: any, right: any) => (
            Number(left?.chassis_index || 0) - Number(right?.chassis_index || 0)
            || Number(left?.slot_row || 0) - Number(right?.slot_row || 0)
            || Number(left?.slot_column || 0) - Number(right?.slot_column || 0)
        ));
    }

    private reconcileBulkManualPlacements() {
        this.bulkManualPlacements = this.normalizeBulkManualPlacements(
            this.bulkManualPlacements,
        );
        this.bulkManualDraftPlacements = this.normalizeBulkManualPlacements(
            this.bulkManualDraftPlacements,
        );
        this.bulkManualChassisIndex = Math.max(
            0,
            Math.min(
                this.bulkManualChassisIndex,
                Math.max(0, this.generatedChassisNames.length - 1),
            ),
        );
    }

    public async selectBulkMappingMode(mode: string) {
        if (mode === 'manual') {
            const returnMode = this.bulkMappingMode === 'manual'
                ? 'manual'
                : this.bulkMappingMode;
            await this.openBulkManualMapper(returnMode);
            return;
        }
        this.bulkMappingMode = mode === 'none' ? 'none' : 'auto';
        this.editorError = '';
        this.clearBulkManualDragState();
        await this.service.render();
    }

    public async openBulkManualMapper(returnMode?: string) {
        this.reconcileBulkManualPlacements();
        this.bulkManualReturnMode = typeof returnMode === 'string'
            ? returnMode
            : this.bulkMappingMode;
        this.bulkMappingMode = 'manual';
        this.bulkManualDraftPlacements = this.bulkManualPlacements.map(
            (placement: any) => ({ ...placement }),
        );
        this.bulkManualChassisIndex = Math.max(
            0,
            Math.min(
                this.bulkManualChassisIndex,
                Math.max(0, this.generatedChassisNames.length - 1),
            ),
        );
        this.bulkManualSearchText = '';
        this.bulkManualError = '';
        this.bulkManualOpen = true;
        this.clearBulkManualDragState();
        await this.service.render();
    }

    public async cancelBulkManualMapper() {
        this.bulkMappingMode = ['auto', 'none', 'manual'].includes(
            this.bulkManualReturnMode,
        ) ? this.bulkManualReturnMode : 'auto';
        this.bulkManualOpen = false;
        this.bulkManualDraftPlacements = [];
        this.bulkManualError = '';
        this.clearBulkManualDragState();
        await this.service.render();
    }

    public async applyBulkManualMapping() {
        this.bulkManualDraftPlacements = this.normalizeBulkManualPlacements(
            this.bulkManualDraftPlacements,
        );
        this.bulkManualError = this.bulkManualDraftPlacementError;
        if (this.bulkManualError) {
            await this.service.render();
            return;
        }
        this.bulkManualPlacements = this.bulkManualDraftPlacements.map(
            (placement: any) => ({ ...placement }),
        );
        this.bulkMappingMode = 'manual';
        this.bulkManualReturnMode = 'manual';
        this.bulkManualOpen = false;
        this.bulkManualDraftPlacements = [];
        this.bulkManualError = '';
        this.editorError = '';
        this.clearBulkManualDragState();
        await this.service.render();
    }

    private bulkManualErrorFor(rows: any[]): string {
        if (this.nodeSelectionCapacityError) return this.nodeSelectionCapacityError;
        if (this.includedNodeIds.length === 0) {
            return '수동 매핑할 포함 장비(Node)를 1개 이상 선택하세요.';
        }
        const placedIds = new Set(
            rows.map((placement: any) => Number(placement?.node_id || 0)),
        );
        const missing = this.includedNodeIds.filter(
            (nodeId: number) => !placedIds.has(Number(nodeId)),
        ).length;
        if (missing > 0) {
            return '포함 장비 ' + missing
                + '개가 아직 Chassis Slot에 배치되지 않았습니다.';
        }
        return '';
    }

    public get bulkManualPlacementError(): string {
        if (
            this.registrationMode !== 'bulk'
            || this.bulkMappingMode !== 'manual'
        ) return '';
        return this.bulkManualErrorFor(this.bulkManualPlacements);
    }

    public get bulkManualDraftPlacementError(): string {
        return this.bulkManualErrorFor(this.bulkManualDraftPlacements);
    }

    public get bulkManualUnplacedCount(): number {
        const placedIds = new Set(
            this.bulkManualDraftPlacements.map(
                (placement: any) => Number(placement?.node_id || 0),
            ),
        );
        return this.includedNodeIds.filter(
            (nodeId: number) => !placedIds.has(Number(nodeId)),
        ).length;
    }

    public get bulkManualUnplacedNodes(): any[] {
        const placedIds = new Set(
            this.bulkManualDraftPlacements.map(
                (placement: any) => Number(placement?.node_id || 0),
            ),
        );
        const term = String(this.bulkManualSearchText || '').trim().toLowerCase();
        return this.includedNodes.filter((node: any) => {
            if (placedIds.has(Number(node?.id || 0))) return false;
            if (!term) return true;
            return [
                node?.name,
                node?.ip_address,
                node?.bmc_ip,
                node?.group_name,
                node?.cluster_name,
            ].some(
                (value: any) => String(value || '').toLowerCase().includes(term),
            );
        });
    }

    public get bulkManualCurrentChassisName(): string {
        return String(
            this.generatedChassisNames[this.bulkManualChassisIndex] || '-',
        );
    }

    public get bulkManualCurrentPlacements(): any[] {
        return this.bulkManualDraftPlacements.filter(
            (placement: any) => Number(placement?.chassis_index)
                === this.bulkManualChassisIndex,
        );
    }

    public get bulkManualCurrentMappedCount(): number {
        return this.bulkManualCurrentPlacements.length;
    }

    public bulkManualPlacementAt(slot: any): any {
        return this.bulkManualCurrentPlacements.find((placement: any) => (
            Number(placement?.slot_row || 0) === Number(slot?.row || 0)
            && Number(placement?.slot_column || 0) === Number(slot?.column || 0)
        )) || null;
    }

    private bulkManualPlacementForNode(nodeId: number): any {
        return this.bulkManualDraftPlacements.find(
            (placement: any) => Number(placement?.node_id || 0) === Number(nodeId),
        ) || null;
    }

    public bulkManualPlacementNode(placement: any): any {
        return this.nodeById(Number(placement?.node_id || 0));
    }

    public async changeBulkManualChassis(index: number) {
        this.bulkManualChassisIndex = Math.max(
            0,
            Math.min(
                Math.floor(Number(index || 0)),
                Math.max(0, this.generatedChassisNames.length - 1),
            ),
        );
        this.clearBulkManualDragState();
        await this.service.render();
    }

    private bulkManualDragModeForSlot(slot: any): string {
        const occupant = this.bulkManualPlacementAt(slot);
        const occupantId = Number(occupant?.node_id || 0);
        const source = this.bulkManualPlacementForNode(
            this.bulkManualDraggedNodeId,
        );
        if (
            occupantId > 0
            && occupantId !== this.bulkManualDraggedNodeId
        ) return source ? 'swap' : 'replace';
        return source ? 'move' : 'place';
    }

    public onBulkManualNodeDragStart(
        node: any,
        event: DragEvent,
    ) {
        const nodeId = Number(node?.node_id || node?.id || 0);
        if (nodeId <= 0 || !this.includedNodeIds.includes(nodeId)) {
            event.preventDefault();
            this.clearBulkManualDragState();
            return;
        }
        this.bulkManualDraggedNodeId = nodeId;
        this.bulkManualDragShadow = null;
        this.bulkManualUnassignActive = false;
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData(
                'application/x-kiera-bulk-manual-node',
                String(nodeId),
            );
            event.dataTransfer.setData('text/plain', String(nodeId));
        }
    }

    public onBulkManualSlotDragOver(slot: any, event: DragEvent) {
        if (this.bulkManualDraggedNodeId <= 0) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        const next = {
            chassis_index: this.bulkManualChassisIndex,
            row: Number(slot?.row || 0),
            column: Number(slot?.column || 0),
            mode: this.bulkManualDragModeForSlot(slot),
        };
        if (
            Number(this.bulkManualDragShadow?.chassis_index) === next.chassis_index
            && Number(this.bulkManualDragShadow?.row || 0) === next.row
            && Number(this.bulkManualDragShadow?.column || 0) === next.column
            && String(this.bulkManualDragShadow?.mode || '') === next.mode
            && !this.bulkManualUnassignActive
        ) return;
        this.bulkManualUnassignActive = false;
        this.bulkManualDragShadow = next;
        this.renderDragState();
    }

    public onBulkManualSlotDragLeave(slot: any, event: DragEvent) {
        const target = event.currentTarget as HTMLElement | null;
        const related = (event as any)?.relatedTarget as Node | null;
        if (target && related && target.contains(related)) return;
        if (
            Number(this.bulkManualDragShadow?.chassis_index)
                !== this.bulkManualChassisIndex
            || Number(this.bulkManualDragShadow?.row || 0)
                !== Number(slot?.row || 0)
            || Number(this.bulkManualDragShadow?.column || 0)
                !== Number(slot?.column || 0)
        ) return;
        this.bulkManualDragShadow = null;
        this.renderDragState();
    }

    public async dropBulkManualNodeOnSlot(slot: any, event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const transferred = Number(
            event.dataTransfer?.getData('application/x-kiera-bulk-manual-node')
            || event.dataTransfer?.getData('text/plain')
            || 0,
        );
        const nodeId = transferred || this.bulkManualDraggedNodeId;
        const node = this.nodeById(nodeId);
        if (!node || !this.includedNodeIds.includes(nodeId)) {
            this.bulkManualError = '포함 장비만 수동 배치할 수 있습니다.';
            this.clearBulkManualDragState();
            await this.service.render();
            return;
        }

        const sourcePlacement = this.bulkManualPlacementForNode(nodeId);
        const occupant = this.bulkManualPlacementAt(slot);
        const occupantId = Number(occupant?.node_id || 0);
        const targetRow = Number(slot?.row || 1);
        const targetColumn = Number(slot?.column || 1);
        const replacedIds = new Set<number>([nodeId]);
        if (occupantId > 0) replacedIds.add(occupantId);

        const nextPlacements = this.bulkManualDraftPlacements.filter(
            (placement: any) => !replacedIds.has(
                Number(placement?.node_id || 0),
            ),
        );
        if (
            occupantId > 0
            && occupantId !== nodeId
            && sourcePlacement
        ) {
            nextPlacements.push({
                ...occupant,
                chassis_index: Number(sourcePlacement?.chassis_index || 0),
                slot_row: Number(sourcePlacement?.slot_row || 1),
                slot_column: Number(sourcePlacement?.slot_column || 1),
            });
        }
        nextPlacements.push({
            chassis_index: this.bulkManualChassisIndex,
            node_id: nodeId,
            name: String(node?.name || 'Node-' + nodeId),
            group_name: String(node?.group_name || ''),
            cluster_name: String(node?.cluster_name || ''),
            ip_address: String(node?.ip_address || ''),
            bmc_ip: String(node?.bmc_ip || ''),
            slot_row: targetRow,
            slot_column: targetColumn,
        });
        this.bulkManualDraftPlacements = this.normalizeBulkManualPlacements(
            nextPlacements,
        );
        this.bulkManualError = '';
        this.clearBulkManualDragState();
        await this.service.render();
    }

    public onBulkManualUnassignDragOver(event: DragEvent) {
        if (
            this.bulkManualDraggedNodeId <= 0
            || !this.bulkManualPlacementForNode(this.bulkManualDraggedNodeId)
        ) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        if (this.bulkManualUnassignActive && !this.bulkManualDragShadow) return;
        this.bulkManualUnassignActive = true;
        this.bulkManualDragShadow = null;
        this.renderDragState();
    }

    public async dropBulkManualNodeToUnassigned(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const transferred = Number(
            event.dataTransfer?.getData('application/x-kiera-bulk-manual-node')
            || event.dataTransfer?.getData('text/plain')
            || 0,
        );
        const nodeId = transferred || this.bulkManualDraggedNodeId;
        this.bulkManualDraftPlacements = this.bulkManualDraftPlacements.filter(
            (placement: any) => Number(placement?.node_id || 0) !== nodeId,
        );
        this.bulkManualError = '';
        this.clearBulkManualDragState();
        await this.service.render();
    }

    public async removeBulkManualPlacement(placement: any) {
        const nodeId = Number(placement?.node_id || 0);
        this.bulkManualDraftPlacements = this.bulkManualDraftPlacements.filter(
            (item: any) => Number(item?.node_id || 0) !== nodeId,
        );
        this.bulkManualError = '';
        this.clearBulkManualDragState();
        await this.service.render();
    }

    public async clearBulkManualCurrentPlacements() {
        if (this.bulkManualCurrentPlacements.length === 0) return;
        const confirmed = await this.service.modal.show({
            title: '현재 Chassis 배치 제거',
            message: '\'' + this.bulkManualCurrentChassisName
                + '\'의 Slot 배치를 모두 제거하시겠습니까?',
            action: '배치 제거',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning',
        });
        if (!confirmed) return;
        this.bulkManualDraftPlacements = this.bulkManualDraftPlacements.filter(
            (placement: any) => Number(placement?.chassis_index)
                !== this.bulkManualChassisIndex,
        );
        this.bulkManualError = '';
        this.clearBulkManualDragState();
        await this.service.render();
    }

    public async onBulkManualDragEnd() {
        this.clearBulkManualDragState();
        await this.service.render();
    }

    private clearBulkManualDragState() {
        this.bulkManualDraggedNodeId = 0;
        this.bulkManualDragShadow = null;
        this.bulkManualUnassignActive = false;
    }

    public isBulkManualShadowSlot(slot: any): boolean {
        return (
            Number(this.bulkManualDragShadow?.chassis_index)
                === this.bulkManualChassisIndex
            && Number(this.bulkManualDragShadow?.row || 0)
                === Number(slot?.row || 0)
            && Number(this.bulkManualDragShadow?.column || 0)
                === Number(slot?.column || 0)
        );
    }

    public bulkManualDragShadowLabel(slot: any): string {
        if (!this.isBulkManualShadowSlot(slot)) return '';
        const mode = String(this.bulkManualDragShadow?.mode || '');
        if (mode === 'swap') return '위치 교환';
        if (mode === 'replace') return '덮어쓰기';
        if (mode === 'move') return '여기로 이동';
        return '여기에 배치';
    }

    public get bulkMappedNodes(): any[] {
        const rows = this.includedNodeIds
            .map((id: number) => this.nodeById(id))
            .filter((node: any) => Boolean(node));
        const compare = (left: any, right: any) => {
            if (this.bulkSortKey === 'ip') {
                return String(left?.ip_address || '').localeCompare(
                    String(right?.ip_address || ''),
                    undefined,
                    { numeric: true, sensitivity: 'base' },
                );
            }
            if (this.bulkSortKey === 'group') {
                return String(left?.group_name || '').localeCompare(
                    String(right?.group_name || ''),
                    undefined,
                    { numeric: true, sensitivity: 'base' },
                ) || this.compareNodeNames(left, right);
            }
            return this.compareNodeNames(left, right);
        };
        return rows.sort(compare);
    }

    public get bulkMappableSlotCount(): number {
        if (this.bulkMappingMode === 'none') return 0;
        if (this.bulkMappingMode === 'manual') {
            return Math.min(this.bulkManualPlacements.length, this.bulkTotalSlots);
        }
        return Math.min(this.bulkMappedNodes.length, this.bulkTotalSlots);
    }

    public get bulkUnmappedSlotCount(): number {
        return Math.max(0, this.bulkTotalSlots - this.bulkMappableSlotCount);
    }

    private bulkPreview(limit?: number): any[] {
        const names = typeof limit === 'number'
            ? this.generatedChassisNames.slice(0, limit)
            : this.generatedChassisNames;
        const nodes = this.bulkMappingMode === 'none' ? [] : this.bulkMappedNodes;
        const displaySlots = this.slots;
        const mappingSlots = this.mappingSlots;
        const manualBySlot = new Map<string, any>();
        if (this.bulkMappingMode === 'manual') {
            for (const placement of this.bulkManualPlacements) {
                const key = Number(placement?.chassis_index || 0)
                    + ':' + Number(placement?.slot_row || 0)
                    + ':' + Number(placement?.slot_column || 0);
                manualBySlot.set(key, this.nodeById(
                    Number(placement?.node_id || 0),
                ));
            }
        }
        return names.map((name: string, chassisIndex: number) => ({
            name,
            slots: displaySlots.map((slot: any) => {
                if (this.bulkMappingMode === 'manual') {
                    const key = chassisIndex + ':' + Number(slot?.row || 0)
                        + ':' + Number(slot?.column || 0);
                    return {
                        slot,
                        node: manualBySlot.get(key) || null,
                    };
                }
                const mappingIndex = mappingSlots.findIndex(
                    (candidate: any) => candidate.key === slot.key,
                );
                return {
                    slot,
                    node: nodes[
                        chassisIndex * this.slotCount + mappingIndex
                    ] || null,
                };
            }),
        }));
    }

    public get bulkStepPreviewRows(): any[] {
        return this.bulkPreview();
    }

    public get bulkConfirmationRows(): any[] {
        return this.bulkPreview(5);
    }

    private dragModeForSlot(slot: any): string {
        const occupant = this.placementAt(slot);
        const occupantId = Number(occupant?.node_id || 0);
        const source = this.placementForNode(this.draggedNodeId);
        if (occupantId > 0 && occupantId !== this.draggedNodeId) {
            return source ? 'swap' : 'replace';
        }
        return source ? 'move' : 'place';
    }

    public dragShadowLabel(slot: any): string {
        if (!this.isShadowSlot(slot)) return '';
        const mode = String(this.dragShadow?.mode || '');
        if (mode === 'swap') return '위치 교환';
        if (mode === 'replace') return '덮어쓰기';
        if (mode === 'move') return '여기로 이동';
        return '여기에 배치';
    }

    private renderDragState() {
        if (this.dragRenderPending) return;
        this.dragRenderPending = true;
        window.requestAnimationFrame(() => {
            this.dragRenderPending = false;
            void this.service.render();
        });
    }

    public onNodeDragStart(
        node: any,
        event: DragEvent,
        fromPreview: boolean = false,
    ) {
        const nodeId = Number(node?.node_id || node?.id || 0);
        if (nodeId <= 0) {
            event.preventDefault();
            this.clearDragState();
            return;
        }
        this.draggedNodeId = nodeId;
        this.draggedFromPreview = Boolean(
            fromPreview && this.placementForNode(nodeId),
        );
        this.dragShadow = null;
        this.placementRemoveDropActive = false;
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData(
                'application/x-kiera-chassis-node',
                String(nodeId),
            );
            event.dataTransfer.setData('text/plain', String(nodeId));
        }
    }

    public onSlotDragOver(slot: any, event: DragEvent) {
        if (this.draggedNodeId <= 0) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        const removeDropWasActive = this.placementRemoveDropActive;
        this.placementRemoveDropActive = false;
        const next = {
            node_id: this.draggedNodeId,
            row: Number(slot?.row || 0),
            column: Number(slot?.column || 0),
            mode: this.dragModeForSlot(slot),
        };
        if (
            Number(this.dragShadow?.row || 0) === next.row
            && Number(this.dragShadow?.column || 0) === next.column
            && String(this.dragShadow?.mode || '') === next.mode
            && !removeDropWasActive
        ) return;
        this.dragShadow = next;
        this.renderDragState();
    }

    public onSlotDragLeave(slot: any, event: DragEvent) {
        const target = event.currentTarget as HTMLElement | null;
        const related = (event as any)?.relatedTarget as Node | null;
        if (target && related && target.contains(related)) return;
        if (
            Number(this.dragShadow?.row || 0) !== Number(slot?.row || 0)
            || Number(this.dragShadow?.column || 0) !== Number(slot?.column || 0)
        ) return;
        this.dragShadow = null;
        this.renderDragState();
    }

    public onChassisPreviewDragOver(event: DragEvent) {
        if (this.draggedNodeId <= 0) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        if (!this.placementRemoveDropActive && !this.dragShadow) return;
        this.placementRemoveDropActive = false;
        this.dragShadow = null;
        this.renderDragState();
    }

    public async cancelChassisPreviewDrop(event: DragEvent) {
        if (this.draggedNodeId <= 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.clearDragState();
        await this.service.render();
    }

    public onChassisOutsideDragOver(event: DragEvent) {
        if (!this.draggedFromPreview) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        if (this.placementRemoveDropActive && !this.dragShadow) return;
        this.placementRemoveDropActive = true;
        this.dragShadow = null;
        this.renderDragState();
    }

    public async dropChassisPlacementOutside(event: DragEvent) {
        if (!this.draggedFromPreview) return;
        event.preventDefault();
        event.stopPropagation();
        const transferred = Number(
            event.dataTransfer?.getData('application/x-kiera-chassis-node')
            || event.dataTransfer?.getData('text/plain')
            || 0,
        );
        const nodeId = transferred || this.draggedNodeId;
        const placement = this.placementForNode(nodeId);
        this.clearDragState();
        if (!placement) {
            await this.service.render();
            return;
        }
        await this.removePlacement(placement);
    }

    public async dropNodeOnSlot(slot: any, event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const transferred = Number(
            event.dataTransfer?.getData('application/x-kiera-chassis-node')
            || event.dataTransfer?.getData('text/plain')
            || 0,
        );
        const nodeId = transferred || this.draggedNodeId;
        const node = this.nodeById(nodeId);
        if (!node || !node?.available) {
            this.clearDragState();
            await this.service.render();
            return;
        }
        if (!this.includedNodeIds.includes(nodeId)) {
            if (this.includedNodeIds.length >= this.slotCount) {
                this.editorError = '배치할 빈 Chassis Slot이 없습니다.';
                this.clearDragState();
                await this.service.render();
                return;
            }
            this.includedNodeIds = [...this.includedNodeIds, nodeId];
            this.availableSelection = this.availableSelection.filter(
                (id: number) => id !== nodeId,
            );
        }

        const sourcePlacement = this.placementForNode(nodeId);
        const occupant = this.placementAt(slot);
        const occupantId = Number(occupant?.node_id || 0);
        const targetRow = Number(slot?.row || 1);
        const targetColumn = Number(slot?.column || 1);
        const replacedIds = new Set<number>([nodeId]);
        if (occupantId > 0) replacedIds.add(occupantId);

        const nextPlacements = this.placements.filter(
            (placement: any) => !replacedIds.has(
                Number(placement?.node_id || 0),
            ),
        );
        if (occupantId > 0 && occupantId !== nodeId && sourcePlacement) {
            nextPlacements.push({
                ...occupant,
                slot_row: Number(sourcePlacement?.slot_row || 1),
                slot_column: Number(sourcePlacement?.slot_column || 1),
            });
        }
        if (occupantId > 0 && occupantId !== nodeId && !sourcePlacement) {
            this.includedNodeIds = this.includedNodeIds.filter(
                (id: number) => id !== occupantId,
            );
        }
        nextPlacements.push({
            node_id: nodeId,
            name: String(node?.name || 'Node-' + nodeId),
            group_name: String(node?.group_name || ''),
            cluster_name: String(node?.cluster_name || ''),
            ip_address: String(node?.ip_address || ''),
            bmc_ip: String(node?.bmc_ip || ''),
            slot_row: targetRow,
            slot_column: targetColumn,
        });
        this.placements = nextPlacements.sort((left: any, right: any) => (
            Number(left?.slot_row || 0) - Number(right?.slot_row || 0)
            || Number(left?.slot_column || 0) - Number(right?.slot_column || 0)
        ));
        this.editorError = '';
        this.clearDragState();
        await this.service.render();
    }

    public async placeInNextSlot(node: any) {
        const used = new Set(
            this.placements.map(
                (placement: any) => String(placement?.slot_row)
                    + ':' + String(placement?.slot_column),
            ),
        );
        const slot = this.slots.find((item: any) => !used.has(item.key));
        if (!slot) {
            this.editorError = '배치할 빈 Chassis Slot이 없습니다.';
            await this.service.render();
            return;
        }
        this.draggedNodeId = Number(node?.id || node?.node_id || 0);
        this.draggedFromPreview = false;
        const fakeEvent: any = {
            preventDefault: () => undefined,
            stopPropagation: () => undefined,
            dataTransfer: { getData: () => String(this.draggedNodeId) },
        };
        await this.dropNodeOnSlot(slot, fakeEvent as DragEvent);
    }

    public async removePlacement(placement: any, removeSelection: boolean = false) {
        const nodeId = Number(placement?.node_id || 0);
        this.placements = this.placements.filter(
            (item: any) => Number(item?.node_id || 0) !== nodeId,
        );
        if (removeSelection) {
            this.includedNodeIds = this.includedNodeIds.filter(
                (id: number) => id !== nodeId,
            );
        }
        this.editorError = '';
        await this.service.render();
    }

    public async clearPlacements() {
        if (this.placements.length === 0) return;
        const confirmed = await this.service.modal.show({
            title: 'Slot 배치 일괄 제거',
            message: '선택한 Node는 유지하고 모든 Slot 배치만 제거하시겠습니까?',
            action: '일괄 제거',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning',
        });
        if (!confirmed) return;
        this.placements = [];
        this.editorError = '';
        this.clearDragState();
        await this.service.render();
    }

    public async onDragEnd() {
        this.clearDragState();
        await this.service.render();
    }

    private clearDragState() {
        this.draggedNodeId = 0;
        this.draggedFromPreview = false;
        this.dragShadow = null;
        this.placementRemoveDropActive = false;
    }

    public isShadowSlot(slot: any): boolean {
        return (
            Number(this.dragShadow?.row || 0) === Number(slot?.row || 0)
            && Number(this.dragShadow?.column || 0) === Number(slot?.column || 0)
        );
    }

    private bulkItems(): any[] {
        const nodes = this.bulkMappingMode === 'none' ? [] : this.bulkMappedNodes;
        const slots = this.mappingSlots;
        const model = this.selectedModel || {};
        const manualByChassis = new Map<number, any[]>();
        if (this.bulkMappingMode === 'manual') {
            for (const placement of this.bulkManualPlacements) {
                const chassisIndex = Number(placement?.chassis_index || 0);
                const rows = manualByChassis.get(chassisIndex) || [];
                rows.push(placement);
                manualByChassis.set(chassisIndex, rows);
            }
        }
        return this.generatedChassisNames.map((name: string, chassisIndex: number) => {
            const manualPlacements = (manualByChassis.get(chassisIndex) || [])
                .sort((left: any, right: any) => (
                    Number(left?.slot_row || 0) - Number(right?.slot_row || 0)
                    || Number(left?.slot_column || 0) - Number(right?.slot_column || 0)
                ));
            const chassisNodes = this.bulkMappingMode === 'manual'
                ? manualPlacements
                    .map((placement: any) => this.nodeById(
                        Number(placement?.node_id || 0),
                    ))
                    .filter((node: any) => Boolean(node))
                : nodes.slice(
                    chassisIndex * this.slotCount,
                    (chassisIndex + 1) * this.slotCount,
                );
            const placements = this.bulkMappingMode === 'manual'
                ? manualPlacements.map((placement: any) => ({
                    node_id: Number(placement?.node_id || 0),
                    slot_row: Number(placement?.slot_row || 0),
                    slot_column: Number(placement?.slot_column || 0),
                }))
                : chassisNodes.map((node: any, slotIndex: number) => ({
                    node_id: Number(node?.id || 0),
                    slot_row: Number(slots[slotIndex]?.row || 1),
                    slot_column: Number(slots[slotIndex]?.column || slotIndex + 1),
                }));
            return {
                name,
                model: String(model?.name || this.form?.model || ''),
                serial: '',
                description: String(model?.description || this.form?.description || ''),
                slot_rows: Number(this.form?.slot_rows || 1),
                slot_columns: Number(this.form?.slot_columns || 1),
                unit_size: Number(this.form?.unit_size || 1),
                active: true,
                node_ids: chassisNodes.map((node: any) => Number(node?.id || 0)),
                placements,
            };
        });
    }

    public async saveChassis() {
        this.editorError = this.stepOneError
            || this.nodeSelectionCapacityError
            || this.bulkManualPlacementError;
        if (!this.editorError && this.registrationMode === 'single') {
            this.editorError = this.placementError;
        }
        if (this.editorError) {
            await this.service.render();
            return;
        }
        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        const singlePayload = {
            id: this.editingId,
            name: String(this.form?.name || '').trim(),
            model: String(this.form?.model || '').trim(),
            serial: String(this.form?.serial || '').trim(),
            description: String(this.form?.description || '').trim(),
            slot_rows: Number(this.form?.slot_rows || 1),
            slot_columns: Number(this.form?.slot_columns || 1),
            unit_size: Number(this.form?.unit_size || 1),
            active: Boolean(this.form?.active),
            rack_id: this.editingId > 0 ? 0 : Number(this.form?.rack_record_id || 0),
            unit_order: this.editingId > 0 ? 0 : Number(this.form?.unit_order || 0),
            node_ids: this.includedNodeIds.map(Number),
            placements: this.placements.map((placement: any) => ({
                node_id: Number(placement?.node_id || 0),
                slot_row: Number(placement?.slot_row || 0),
                slot_column: Number(placement?.slot_column || 0),
            })),
        };
        const payload = (
            this.registrationMode === 'bulk' && this.editingId <= 0
        ) ? {
            mode: 'bulk',
            items: this.bulkItems(),
        } : singlePayload;
        try {
            const { code, data } = await wiz.call('save', {
                data: JSON.stringify(payload),
            });
            if (code !== 200) {
                this.editorError = data?.message || 'Chassis를 저장하지 못했습니다.';
                return;
            }
            this.applySnapshot(data?.snapshot);
            const count = Number(data?.created_count || 1);
            if (this.registrationMode === 'bulk' && this.editingId <= 0) {
                this.noticeMessage = 'Chassis ' + count + '대를 생성했습니다.';
            } else {
                const action = this.editingId > 0 ? '수정' : '생성';
                this.noticeMessage = String(data?.chassis?.name || singlePayload.name)
                    + '을(를) ' + action + '했습니다.';
            }
            this.initialState = '';
            await this.closeEditor(true);
        } catch (error) {
            this.editorError = String(error || 'Chassis를 저장하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public chassisDeleteMessage(item: any): string {
        const chassisName = String(item?.name || 'Chassis');
        const rackId = Number(item?.rack_record_id || item?.rack_id || 0);
        if (rackId > 0) {
            const rackName = String(item?.rack_name || '').trim();
            const rackLabel = rackName || 'Rack #' + rackId;
            return '\'' + chassisName + '\'은(는) ' + rackLabel
                + '에 배치 중입니다. 그래도 삭제하시겠습니까? '
                + '삭제하면 Rack에서도 Chassis가 빠지고 포함 Node는 미할당 상태로 전환됩니다.';
        }
        return '\'' + chassisName
            + '\'을(를) 삭제하시겠습니까? 포함 Node는 미할당 상태로 전환됩니다.';
    }

    public async deleteChassis(item: any, event?: Event) {
        event?.stopPropagation();
        const chassisId = Number(item?.id || 0);
        if (chassisId <= 0 || this.deletingId > 0) return;
        const confirmed = await this.service.modal.show({
            title: 'Chassis 삭제',
            message: this.chassisDeleteMessage(item),
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error',
        });
        if (!confirmed) return;
        this.deletingId = chassisId;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete', { id: chassisId });
            if (code !== 200) {
                this.errorMessage = data?.message || 'Chassis를 삭제하지 못했습니다.';
                return;
            }
            this.applySnapshot(data?.snapshot);
            this.noticeMessage = String(item?.name || 'Chassis') + '을(를) 삭제했습니다.';
        } catch (error) {
            this.errorMessage = String(error || 'Chassis를 삭제하지 못했습니다.');
        } finally {
            this.deletingId = 0;
            await this.service.render();
        }
    }
}

export default PageKieraChassisComponent;
